import { animated } from "@react-spring/web";
import { useTranslation } from "react-i18next";
import PowerrailImage from "/assets/images/ApplicationsIcons/powerrail.svg";
import DynamicImage from "/assets/images/ApplicationsIcons/dynamiccharge.svg";
import PowerfloorImage from "/assets/images/ApplicationsIcons/powerfloor.svg";
import StaticImage from "/assets/images/ApplicationsIcons/staticcharge.svg";
import { useSnapshot } from "valtio";
import store from "../../../../appStore";
import { useMemo } from "react";
import IndustryApplication from "./IndustryApplication";
import { useSpring } from "react-spring";

const applicationsCharge = [
  {
    name: "powerrail",
    textId: "L4_INDUSTRIES_POWERRAIL",
    image: PowerrailImage,
    color: "#FF7E88",
    href: "charge/c-products/p-powerrail",
    industries: ["c-automotive", "logistic", "amusement"],
  },
  {
    name: "dynamic",
    textId: "L4_INDUSTRIES_DYNAMIC",
    image: DynamicImage,
    color: "#FFC37E",
    href: "charge/c-products/p-dynamic-charge",
    industries: ["airport", "logistic"],
  },
  {
    name: "powerfloor",
    textId: "L4_INDUSTRIES_POWERFLOOR",
    image: PowerfloorImage,
    color: "#61DFFF ",
    href: "charge/c-products/p-powerfloor",
    industries: ["c-automotive", "logistic", "amusement"],
  },
  {
    name: "static",
    textId: "L4_INDUSTRIES_STATIC",
    image: StaticImage,
    color: "#97E58B",
    href: "charge/c-products/p-static-charge",
    industries: ["airport", "logistic"],
  },
];

const ChargeIndustriesApplicationsUI = ({ industryId = "airport", visible = false, ...props }) => {
  const snap = useSnapshot(store);

  const { t } = useTranslation();

  const applications = useMemo(() => {
    return applicationsCharge.filter((a) => a.industries.includes(industryId));
  }, [industryId]);

  const { opacity } = useSpring({
    opacity: visible ? 1 : 0,
    config: { duration: 200 },
    delay: visible ? 500 : 0,
  });

  return (
    <animated.div
      style={{
        position: "absolute",
        left: "0",
        width: snap.sideBarVisible && !snap.sideBarToggle ? "73vw" : "100vw",
        transition: "0.5s",
        zIndex: "1",
        // height: "15vh",
        bottom: "5vh",
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        pointerEvents: "none",
        opacity: opacity,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          color: "#fff",
          fontSize: "0.75vw",
          marginRight: "1vw",
        }}
      >
        {/* {t("L3_APPLICATIONS_IP_FEATURES")} */}
        {t("L3_INDUSTRIES_DESCRIPTION_APPLICATIONS")}
      </div>

      {applications.map((application, i) => {
        return <IndustryApplication key={i} application={application} />;
      })}
    </animated.div>
  );
};

export default ChargeIndustriesApplicationsUI;
